import { render, staticRenderFns } from "./ListMessageCounter.vue?vue&type=template&id=a35af8ae&scoped=true&"
import script from "./ListMessageCounter.vue?vue&type=script&lang=js&"
export * from "./ListMessageCounter.vue?vue&type=script&lang=js&"
import style0 from "./ListMessageCounter.vue?vue&type=style&index=0&id=a35af8ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35af8ae",
  null
  
)

export default component.exports